import { render, staticRenderFns } from "./BirthEmployee.vue?vue&type=template&id=c04f9846&scoped=true&"
import script from "./BirthEmployee.vue?vue&type=script&lang=js&"
export * from "./BirthEmployee.vue?vue&type=script&lang=js&"
import style0 from "./BirthEmployee.vue?vue&type=style&index=0&id=c04f9846&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04f9846",
  null
  
)

export default component.exports